export * from './footer.component';



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/footer/index.ts